import palette from './palette';

const button = {
  MuiButton: {
    defaultProps: { disableRipple: true },
    styleOverrides: {
      root: {
        borderRadius: '2px',
        fontSize: '13px',
        fontWeight: 500,
        boxShadow: 'none',
        padding: '10px 32px',
        borderColor: palette.common.white,
        textTransform: 'none',
        height: '40px',
        minWidth: '111px',
      },
      contained: {
        color: palette.common.white,
        background: palette.common.black,
        '&:hover': {
          color: palette.green[400],
          background: palette.green[100],
          borderColor: palette.common.white,
          boxShadow: 'none',
        },
        '&:disabled': {
          color: palette.grey[300],
          background: palette.grey[500],
          borderColor: palette.common.white,
        },
        '&.Mui-focusVisible': {
          '&:hover': {
            color: palette.common.white,
            background: palette.blue[700],
          },
          background: palette.blue[700],
        },
      },
      outlined: {
        color: palette.common.black,
        border: '1px solid',
        borderColor: palette.grey[650],
        '&:hover': {
          borderColor: palette.common.black,
        },
        '&:disabled': {
          color: palette.grey[700],
          background: palette.grey[300],
        },
      },
    },
    variants: [
      {
        props: { size: 'md' },
        style: {
          height: '26px',
        },
      },
      {
        props: { size: 'lg' },
        style: {
          height: '28px',
        },
      },
      {
        props: { size: 'xl' },
        style: {
          height: '34px',
        },
      },
      {
        props: { color: 'blue' },
        style: {
          borderColor: palette.secondary.main,
          '&:hover': {
            borderColor: palette.primary.main,
          },
        },
      },
      {
        props: { variant: 'contained', color: 'blue' },
        style: {
          background: palette.secondary.main,
          '&:hover': {
            background: palette.secondary.main,
          },
        },
      },
      {
        props: { variant: 'clear' },
        style: {
          background: palette.blue[45],
          color: palette.common.black,
          fontWeight: 600,
          padding: '2px 6px',
          '&:hover': {
            background: palette.blue[40],
          },
        },
      },
      {
        props: { variant: 'contained', color: 'grey' },
        style: {
          background: palette.grey[700],
          '&:hover': {
            background: palette.grey[800],
          },
        },
      },
      {
        props: { variant: 'contained', color: 'green' },
        style: {
          background: palette.green[800],
          '&:hover': {
            background: palette.green[800],
          },
        },
      },
      {
        props: { variant: 'outlined', color: 'green' },
        style: {
          background: palette.green[900],
          borderColor: palette.green[950],
          color: palette.common.white,
          fontSize: 14,
        },
      },
      {
        props: { variant: 'outlined', color: 'white' },
        style: {
          background: palette.common.white,
          borderColor: palette.common.white,
          '&:disabled': {
            background: palette.common.white,
          },
        },
      },
      {
        props: { variant: 'print' },
        style: {
          background: palette.common.white,
          border: '1.2px solid',
          borderColor: `${palette.inputs.defaultPrimary} ${palette.inputs.defaultSecondary}`
            + ` ${palette.inputs.defaultSecondary} ${palette.inputs.defaultPrimary}`,
          color: palette.common.black,
          fontSize: '10px',
          fontWeight: 600,
          padding: '4px 8px',
          '&:disabled': {
            borderColor: 'rgba(0, 0, 0, 0.12)',
          },
        },
      },
      {
        props: { variant: 'print-big' },
        style: {
          background: palette.common.white,
          border: '1.2px solid',
          borderColor: `${palette.inputs.defaultPrimary} ${palette.inputs.defaultSecondary}`
            + ` ${palette.inputs.defaultSecondary} ${palette.inputs.defaultPrimary}`,
          color: palette.common.black,
          fontSize: '11px',
          fontWeight: 600,
          padding: '6px 8px',
          '&:disabled': {
            borderColor: 'rgba(0, 0, 0, 0.12)',
          },
        },
      },
      {
        props: { variant: 'input-adornment' },
        style: {
          color: palette.text.primary,
          padding: '4px',
          borderRadius: '6px',
        },
      },
      {
        props: { variant: 'input-adornment', color: 'grey' },
        style: {
          background: palette.grey[400],
          '&:hover': {
            background: palette.grey[300],
          },
        },
      },
      {
        props: { variant: 'input-adornment', color: 'green' },
        style: {
          background: palette.green[500],
          '&:hover': {
            background: palette.green[700],
          },
        },
      },
    ],
  },
};

export default button;
